import { SignInLinkScreen, SignInScreen } from "@otii/ui/sign-in";
import { ROLE_LABEL, type Role } from "@otii/gov-shared";
import { useAuthConfig } from "../../lib/queries";

export function SignIn() {
  const { data: cfg, isLoading } = useAuthConfig();
  return (
    <SignInScreen
      product="Governance"
      tagline="Board & management"
      cfg={cfg}
      isLoading={isLoading}
      roleLabel={(role) => ROLE_LABEL[role as Role] ?? role}
      noUsersHint="No people yet. Set GOV_ADMIN_EMAILS or SEED_DEMO=true."
    />
  );
}

export function SignInLink() {
  return <SignInLinkScreen product="Governance" tagline="Board & management" />;
}
